"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
class CloneApi extends _basic_data_hub_api.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      dataHubUrl,
      userTokenFactory,
      onGraphQLErrors,
      onNetworkError,
      deployerUrl,
      accountId,
      defaultLimit,
      feature
    } = _ref;
    super({
      dataHubUrl,
      userTokenFactory,
      onGraphQLErrors,
      onNetworkError,
      accountId,
      defaultLimit,
      feature
    });
    this.deployerUrl = deployerUrl;
  }
  async cloneCard(cardId) {
    let viewIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return this._callApi({
      method: 'put',
      path: `/cards/${cardId}`,
      payload: {
        holderIds: viewIds
        // holderType: null,
        // cloneDeep: false
      },

      queryParams: {}
    });
  }
  async cloneFlowToBots(flowId, botIds, cloneDeep) {
    return this._callApi({
      method: 'put',
      path: `/flows`,
      payload: {
        flowId,
        botIds,
        cloneView: cloneDeep
      },
      queryParams: {}
    });
  }
  async cloneView(viewId, cloneDeep) {
    let linkIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    let linkType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return this._callApi({
      method: 'put',
      path: `/views/${viewId}`,
      payload: {
        holderIds: linkIds,
        holderType: linkType,
        cloneDeep
      },
      queryParams: {}
    });
  }
}
var _default = CloneApi;
exports.default = _default;